<template>
    <NewsletterBanner/>
    <div class="py-4">
        <div class="container-xxl">
            <div class="d-flex flex-column flex-lg-row align-items-center">
                <NuxtLink class="navbar-brand" :to="siteUrl"></NuxtLink>
                <a class="btn btn-outline-white btn-lg ms-lg-auto px-4 mt-3 mt-lg-0 w-100 w-lg-auto text-decoration-none" :href="`mailto:${contactEmail}`" target="_blank">{{contactEmail}}</a>
            </div>
        </div>
    </div>
        <hr class="my-0">
        <div class="container-xxl mt-4 mt-lg-5">
            <div class="row align-content-center justify-content-center">
                <div class="col-12">
                    <div class="footer-items d-flex flex-wrap flex-column flex-sm-row justify-content-start justify-content-lg-between">
                        <div class="footer-item mb-4">
                            <Hreflang />
                        </div>
                        <FooterMainMenu />
                        <div class="footer-item mb-4 trustbox">
                            <Social />
                            <client-only>
                                <TrustBox />
                            </client-only>
                        </div>
                    </div>
                </div>
            </div>
            <FooterBottomMenu />
        </div>
</template>

<script>
import TrustBox from '~/components/TrustBox.vue';
import FooterMainMenu from '~/components/Menu/FooterMainMenu.vue';
import FooterBottomMenu from '~/components/Menu/FooterBottomMenu.vue';
import NewsletterBanner from '~/components/Layout/NewsletterBanner.vue';

export default {
    components: {NewsletterBanner, FooterBottomMenu, FooterMainMenu, TrustBox},
    computed: {
        siteUrl() {
            return useSettingsStore().get('settings.site_protocol') + '://' +
                useSettingsStore().get('settings.site_domain');
        },
        contactEmail() {
            return useSettingsStore().get('settings.contact_email');
        }
    },
    methods: {},
};
</script>

